<template>
   <div class="van-tabbar--fixed" :style="{
	   	'background-image': `url(${img_db_dt_btm})`,
	   	'background-size':'100% 100%',
		height:'1.3rem',
		width:'100%',
		'z-index':'100'
	   }">
	   <van-tabbar class="zw6KEcLcR0TZl9aKmnoW" v-model="active"  z-index="100">
	       <van-tabbar-item  v-for="(item,index) in tabClass" :key="index" style="position: relative;z-index: 99;display: flex;align-items: center;"  @click="routerFun(item)" :name="item.router" >
	           <div>
				   <img :src="active==item.router?item.active.imgSrc:item.tab.imgSrc" style="display: block;margin: 0 auto;margin-bottom:0.04rem;height: .5rem;width: auto;" alt="" sizes="" srcset="" />
				   <span>{{item.className}}</span>
			   </div>
	       </van-tabbar-item>
	   	<!-- config.festival_img -->
	   	<div class="pendant-AGM4D" v-if="[3.0,3.6].indexOf(config.ui_version)" style="width: 100%;">
	   		<img class="pendant-left-keCbM" v-if="config.festival_img.bottom_1 != '#'" :src="config.festival_img.bottom_1" alt="" />
	   		<img class="pendant-center-bQBE8" v-if="config.festival_img.bottom_2 != '#'" :src="config.festival_img.bottom_2" alt="" />
	   		<img class="pendant-right-Pu6sD" v-if="config.festival_img.bottom_3 != '#'" :src="config.festival_img.bottom_3" alt="" />
	   	</div>
	   </van-tabbar>
   </div>
  </template>
   
  <script>
  // 引入从iconfont 下载的symbox文件
  // import '@/assets/icons/iconfont-svg.js'
  // 引入本地的svg文件
  // 定义一个加载目录的函数
  const requireAll = requireContext => requireContext.keys().map(requireContext)
  const req = require.context('@/assets/icons/svg', false, /\.svg$/)
  // 加载目录下的所有的 svg 文件
  requireAll(req)
  import { mapState } from 'vuex';
  export default {
  	computed:{
  		...mapState(['popList','userInfo','moneyInfo','config']),
  		iconName(){
  		  return `${this.prefix}${this.name}`
  		}
  	},
    name: 'Icon',
    props: {
      name: String,
      active: {
        type:[String],
        required:'home',
      },
    },
    data(){
        return {
			// a2fpg-cg754.png
			// a2uzq-rt2ng.png
			//afebo-p082l.png
			//atlaf-xnz27.png
			//akevv-agrvj.png
			img_db_dt_btm:require('./../../assets/4Ddian/img_db_dt_btm.png'),
			tabActive:'',
            tbaCla:{
                "display":"inline-block",
                "position":' relative',
                "width": '0.5rem',
                "height": '0.5rem',
                "backgroundSize":'10.3714rem 10.1214rem',
            },
			toolbarConter:{
				_Inicio:this.$t('toolbarConter._Inicio'),
				_Promoção:this.$t('toolbarConter._Promoção'),
				_Agente:this.$t('toolbarConter._Agente'),
				_Suporte:this.$t('toolbarConter._Suporte'),
				_Perfil:this.$t('toolbarConter._Perfil'),
				_Depósito:this.$t('toolbarConter._Depósito'),
				_Saque:this.$t('toolbarConter._Saque'),
                _Login:this.$t('toolbarConter._Login'),
				_Registro:this.$t('toolbarConter._Registro'),
			},
			// a6p4e-vve3i.png
			
            classList:{
                home:{
                    router:'home',
					className:this.$t('toolbarConter._Inicio'),
                    tab:{
                        "backgroundPosition": '-4.94286rem -6.47143rem',
						"imgSrc":require('./../../assets/4Ddian/a2fpg-cg754.png'),
                    },
                    active:{
                        "backgroundPosition": '-5.45714rem -6.47143rem',
						"imgSrc":require('./../../assets/4Ddian/a6p4e-vve3i.png'),
                    }
                },
                event:{
                    router:'event',
					className:this.$t('toolbarConter._Promoção'),
                    tab:{
                        "backgroundPosition": '-7.28571rem -3.08571rem',
						"imgSrc":require('./../../assets/4Ddian/a2uzq-rt2ng.png'),
                    },
                    active:{
                        "backgroundPosition": '-7.28571rem -3.6rem',
						"imgSrc":require('./../../assets/4Ddian/ajdhr-gnrsi.png'),
                    }
                },
                agente:{
					router:'promote',
					className:this.$t('toolbarConter._Agente'),
                    tab:{
                        "backgroundPosition": '-5.97143rem -6.47143rem',
						"imgSrc":require('./../../assets/4Ddian/apja2-3ov5m.png'),
                    },
                    active:{
                        "backgroundPosition": '-5.97143rem -6.47143rem',
                        "imgSrc":require('./../../assets/4Ddian/apja2-3ov5m.png'),
                    }
                },
                suporte:{
					router:"notice",
					className:this.$t('toolbarConter._Suporte'),
                    tab:{
                        "backgroundPosition": '-5.21429rem -5.95714rem',
						"imgSrc":require('./../../assets/4Ddian/atlaf-xnz27.png'),
                    },
                    active:{
                        "backgroundPosition": '-7.28571rem -3.6rem',
						"imgSrc":require('./../../assets/4Ddian/a2fpg-cg754.png'),
                    }
                },
                mine:{
					router:'mine',
					className:this.$t('toolbarConter._Perfil'),
                    tab:{
                        "backgroundPosition": '-7.28571rem -1.02857rem',
						"imgSrc":require('./../../assets/4Ddian/akevv-agrvj.png'),
                    },
                    active:{
                        "backgroundPosition": '-7.28571rem -1.52857rem',
						"imgSrc":require('./../../assets/4Ddian/a30wv-8um7p.png'),
                    }
                },
                recharge:{
                    router:'tan',
                    className:this.$t('toolbarConter._Depósito'),
                    tab:{
                        "backgroundPosition": '-3.15714rem -5.95714rem',
						"imgSrc":require('./../../assets/4Ddian/afebo-p082l.png'),
                    },
                    active:{
                        "backgroundPosition": '-7.28571rem -3.6rem',
						"imgSrc":require('./../../assets/4Ddian/a2fpg-cg754.png'),
                    }
                },
                withdraw:{
                    router:'withdraw',
                    className:this.$t('toolbarConter._Saque'),
                    tab:{
                        "backgroundPosition": '-6.48571rem -6.47143rem',
						"imgSrc":require('./../../assets/4Ddian/ato7n-1f3bv.png'),
                    },
                    active:{
                        "backgroundPosition": '-7.28571rem -3.6rem',
						"imgSrc":require('./../../assets/4Ddian/a2fpg-cg754.png'),
                    }
                },
                login:{
                    router:'login',
                    className:this.$t('toolbarConter._Login'),
                    tab:{
                        "backgroundPosition": '-3.71429rem -5.95714rem',
						"imgSrc":require('./../../assets/4Ddian/a2fpg-cg754.png'),
                    },
                    active:{
                        "backgroundPosition": '-3.71429rem -5.95714rem',
						"imgSrc":require('./../../assets/4Ddian/a2fpg-cg754.png'),
                    }
                },
                register:{
                    router:'register',
                    className:this.$t('toolbarConter._Registro'),
                    tab:{
                        "backgroundPosition": '-5.97143rem -6.47143rem',
						"imgSrc":require('./../../assets/4Ddian/apja2-3ov5m.png'),
                    },
                    active:{
                        "backgroundPosition": '-5.97143rem -6.47143rem',
                        "imgSrc":require('./../../assets/4Ddian/apja2-3ov5m.png'),
                    }
                },
            },
            tabClass:[]
        };
    },
    methods:{
        routerFun(e){
			if(e.router=='tan'){
				this.$store.commit('isDeposit',true);
				this.active=this.tabActive;
				return false;
			}else if(e.router=='promote'){
				this.$store.commit('isRecord')
				this.$store.commit('publicFun',['isRecordType',0])
			}else if(e.router=='register' || e.router=='login'){
				this.$store.commit('isRecord')
				this.$store.commit('publicFun',['isRecordType',e.router=='register' ? 0 : 1])
				this.active=this.tabActive;
				return false;
			}else{
				if(this.$store.state.userInfo && e.router=='withdraw' ){
					if(!this.$store.state.userInfo.set_withdraw_password){
						this.$router.push({name:'security'})
						return false;
					}
				}
				this.$router.push({name:e.router})
			}
			this.tabActive=e.router;
        }
    },
	created() {
		this.tabActive=this.active;
        let allList = {
            other:{
                unlogin:["home","event","register","suporte","mine"],
                login:["home","event","recharge","withdraw","mine"]
            },
        };
        let useList =  allList.other;
        let isLogin = typeof this._vuex_token()=='string' ? 'login' : 'unlogin';
        this.tabClass = [
            this.classList[useList[isLogin][0]],
            this.classList[useList[isLogin][1]],
            this.classList[useList[isLogin][2]],
            this.classList[useList[isLogin][3]],
            this.classList[useList[isLogin][4]],
        ]
	},
  }
  </script>
   <style>
	   .van-tabbar--fixed{
		   max-width: var(--theme-max-width);
	   }
   </style>
  <style  scoped>
	  .pendant-AGM4D,.pendant-left-keCbM {
	      height: 100%;
	      position: absolute;
	      left: 0;
	      top: 0
	  }
	  .pendant-center-bQBE8 {
	      height: 100%;
	      left: 50%;
	      position: absolute;
	      transform: translateX(-50%)
	  }
	  
	  .pendant-right-Pu6sD {
	      height: 100%;
	      position: absolute;
	      right: 0;
	      top: 0
	  }
    .zw6KEcLcR0TZl9aKmnoW{
       /* background: var(--theme-btm-bg-color);
        background-image: -webkit-gradient(linear, left top, left bottom, from(transparent), to(rgba(84, 84, 84, 0)));
        background-image: linear-gradient(180deg, transparent, rgba(84, 84, 84, 0));
        -webkit-box-shadow: .02rem 0 .06rem 0 rgba(0, 0, 0, .1);
        box-shadow: .02rem 0 .06rem 0 rgba(0, 0, 0, .1); */
		height: 1.24rem;
		margin-top: -.03rem;
		background-repeat: no-repeat;
		background-color:transparent;
    }
    .anticon {
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: inherit;
    display: inline-block;
    font-style: normal;
    line-height: 0;
    text-align: center;
    text-transform: none;
    vertical-align: -.125em;
}
.zw6KEcLcR0TZl9aKmnoW .van-tabbar-item__text {
    word-wrap: break-word;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    height: .54rem;
    line-height: 1.3;
    max-width: 1.6rem;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    vertical-align: middle;
    white-space: pre-wrap;
}

.zw6KEcLcR0TZl9aKmnoW .van-tabbar-item {
	background: transparent;
    -ms-flex-pack: end;
    color: var(--skin__btmnav_def);
    font-size: .24rem;
    justify-content: center;
    padding-top: 0;
    align-items: center;
    /* justify-content: flex-end; */
    position: relative;
}
.zw6KEcLcR0TZl9aKmnoW .van-tabbar-item--active {
    background: transparent;
	font-weight: 700;
    color: var(--skin__btmnav_def);
}
.zw6KEcLcR0TZl9aKmnoW span{
	display: flex;
	width: 100%;
}
  </style>
  